import { render } from "./ClienteTable.vue?vue&type=template&id=06e34716"
import script from "./ClienteTable.vue?vue&type=script&lang=js"
export * from "./ClienteTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__